module.exports = global["bs"] = require("-!.\\npm.js");


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/js/npm.js
// module id = 154
// module chunks = 0